import * as React from 'react'

import { AttendanceCustomTimeRangeDayEnum } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { weekdaysWithUserFirstDayOfWeek } from 'modules/core/lib/firstDayOfWeek'

import type { State } from './reducers'
import { initialState, reducer } from './reducers'

type Context = React.Context<State>

const CustomTimeRangeContext: Context = React.createContext(initialState)

const CustomTimeRangeProvider = ({ children }: React.PropsWithChildren<object>) => {
  const [state, dispatch] = React.useReducer(reducer, initialState)
  const {
    access: { firstDayOfWeek },
  } = useCurrentSession()

  const orderedDayEnums: AttendanceCustomTimeRangeDayEnum[] = [
    // FIXME: The cast is necessary because the function does not know anything about
    //        this enum type from attendance. Either we use the same enum everywhere or
    //        we make the function accept a generic type.
    // eslint-disable-next-line no-type-assertion/no-type-assertion
    ...(weekdaysWithUserFirstDayOfWeek(firstDayOfWeek) as AttendanceCustomTimeRangeDayEnum[]),
    'bank_holiday',
  ]

  return (
    <CustomTimeRangeContext.Provider
      value={{ ...state, customTimeRangeDispatch: dispatch, dayEnums: orderedDayEnums }}
    >
      {children}
    </CustomTimeRangeContext.Provider>
  )
}

const useCustomTimeRange = () => {
  const customTimeRangeContext = React.useContext(CustomTimeRangeContext)

  if (!customTimeRangeContext) {
    throw new Error('useCustomTimeRange hook must be used within a CustomTimeRangeContextProvider')
  }

  return customTimeRangeContext
}

export { CustomTimeRangeProvider, useCustomTimeRange }
